export class TwoFactorWebAuthnDeleteAllRequest {
  constructor(public userVerificationToken: string) {}
}
